export type AppPermissions = {
  isExternal: boolean;
  isInternal: boolean;
  isAdmin: boolean;
  isSuperUser: boolean;
  canViewInboxAll: boolean;
  canViewDeliveryUpload: boolean;
  canViewDeliveryUploaded: boolean;
  canViewDeliveryNew: boolean;
  canViewDeliveryHandled: boolean;
  canViewDocuments: boolean;
  canViewCustomerSettings: boolean;
  canViewAdminPanel: boolean;
  canViewWizard: boolean;
  canViewAllCustomers: boolean;
  canViewInvoiceReport: boolean;
};

export const DEFAULT_PERMISSIONS: AppPermissions = {
  isExternal: false,
  isInternal: false,
  isAdmin: false,
  isSuperUser: false,
  canViewInboxAll: false,
  canViewDeliveryUpload: false,
  canViewDeliveryUploaded: false,
  canViewDeliveryNew: false,
  canViewDeliveryHandled: false,
  canViewDocuments: false,
  canViewCustomerSettings: false,
  canViewAdminPanel: false,
  canViewWizard: false,
  canViewAllCustomers: false,
  canViewInvoiceReport: false,
};
